module.exports = "<div class='resultados'></div>"


//////////////////
// WEBPACK FOOTER
// ./views/busca/index.twig
// module id = 52
// module chunks = 0